import { render, staticRenderFns } from "./NewOrderSendByImage.vue?vue&type=template&id=4834192e&"
import script from "./NewOrderSendByImage.vue?vue&type=script&lang=js&"
export * from "./NewOrderSendByImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports